var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { CopilotAppPage } from '@office-start/office-home-app-shared';
import React from 'react';
import { AiHubSamplePage } from '../Components/AiHubSamplePage/AiHubSamplePage';
import { AppGalleryPage } from '../Components/AppGalleryPage/AppGalleryPage';
import { AppHostPage } from '../Components/AppHostPage/AppHostPage';
import { AssistPage } from '../Components/AssistPage/AssistPage';
import { AutomatePage } from '../Components/AutomatePage/AutomatePage';
import { BizChatNativePage } from '../Components/BizChatNativePage/BizChatNativePage';
import { BrowsePage } from '../Components/BrowsePage/BrowsePage';
import { CatchUpPage } from '../Components/CatchUpPage/CatchUpPage';
import { CollectPage } from '../Components/CollectPage/CollectPage';
import { ContentPage } from '../Components/ContentPage/ContentPage';
import { CopilotPage } from '../Components/CopilotPage/CopilotPage';
import { CreatePage } from '../Components/CreatePage/CreatePage';
import { HomePage } from '../Components/HomePage/HomePage';
import { MyContentPage } from '../Components/MyContentPage/MyContentPage';
import { NewsPage } from '../Components/NewsPage/NewsPage';
import { PeoplePage } from '../Components/People/PeoplePage';
import { PreparePage } from '../Components/PreparePage/PreparePage';
import { SearchPage } from '../Components/SearchPage/SearchPage';
import { StartPage } from '../Components/StartPage/StartPage';
import { TemplatePage } from '../Components/TemplatePage/TemplatePage';
import { ThemeTestPage } from '../Components/ThemeTestPage/ThemeTestPage';
import { WorkplacePage } from '../Components/WorkplacePage/WorkplacePage';
import { actionsRouteGuard, assistRouteGuard, bizChatNativeRouteGuard, browseRouteGuard, catchUpRouteGuard, collectRouteGuard, createRouteGuard, mosAppHostedAtRootRouteGuard, myContentRouteGuard, peopleRouteGuard, prepareRouteGuard, startPageRouteGuard, workplaceRouteGuard, } from './routeGuards';
import { copilotRouteGuard } from './routeGuards/copilotRouteGuard';
import { searchRouteGuard } from './routeGuards/searchPageRouteGuard';
import { MosAppsHostedAtRoot } from './RoutePaths';
var appRoutes = [];
function getAppHostedAtRootPath(prefix, supportedApps) {
    var supportedPaths = supportedApps.map(function (app) {
        return "".concat(prefix, "/").concat(app, "/:entityId?/:subPageId?");
    });
    return supportedPaths;
}
export function getStandaloneCopilotAppRoutes() {
    var copilotAppRoutes = [
        {
            route: {
                path: "/" /* RoutePaths.Home */,
                component: CopilotAppPage,
            },
        },
    ];
    return copilotAppRoutes;
}
export function getOfficeHomeAppRoutes(setContentNode, isStandaloneCopilotApp, scrollContentRef, prefix) {
    if (prefix === void 0) { prefix = ''; }
    if (isStandaloneCopilotApp) {
        return getStandaloneCopilotAppRoutes();
    }
    if (!appRoutes.length) {
        appRoutes = [
            {
                route: {
                    path: prefix + "/aiHubSample/" /* RoutePaths.AiHubSample */,
                    component: AiHubSamplePage,
                },
            },
            {
                route: {
                    path: prefix + "/catchup/" /* RoutePaths.CatchUp */,
                    component: CatchUpPage,
                },
                guard: catchUpRouteGuard,
            },
            {
                route: {
                    path: prefix + "/collect/" /* RoutePaths.Collect */,
                    render: function () {
                        return React.createElement(CollectPage, null);
                    },
                },
                guard: collectRouteGuard,
            },
            {
                route: {
                    path: prefix + "/pages/" /* RoutePaths.Pages */,
                    render: function () {
                        return React.createElement(CollectPage, null);
                    },
                },
                guard: collectRouteGuard,
            },
            {
                route: {
                    path: prefix + "/prepare/" /* RoutePaths.Prepare */,
                    component: PreparePage,
                },
                guard: prepareRouteGuard,
            },
            {
                route: {
                    path: prefix + "/workplace/" /* RoutePaths.Workplace */,
                    render: function () {
                        return React.createElement(WorkplacePage, null);
                    },
                },
                guard: workplaceRouteGuard,
            },
            {
                route: {
                    path: prefix + "/people/" /* RoutePaths.People */,
                    render: function () {
                        return React.createElement(PeoplePage, null);
                    },
                },
                guard: peopleRouteGuard,
            },
            {
                route: {
                    path: prefix + "/browse/" /* RoutePaths.Browse */,
                    render: function () {
                        return React.createElement(BrowsePage, null);
                    },
                },
                guard: browseRouteGuard,
            },
            {
                route: {
                    path: prefix + "/assist/" /* RoutePaths.Assist */,
                    render: function () {
                        return React.createElement(AssistPage, null);
                    },
                },
                guard: assistRouteGuard,
            },
            {
                route: {
                    path: prefix + "/actions/" /* RoutePaths.Actions */,
                    render: function () {
                        return React.createElement(AutomatePage, null);
                    },
                },
                guard: actionsRouteGuard,
            },
            {
                route: {
                    path: prefix + "/bizchat/" /* RoutePaths.BizChatNative */,
                    render: function () {
                        return React.createElement(BizChatNativePage, null);
                    },
                },
                guard: bizChatNativeRouteGuard,
            },
            {
                route: {
                    path: prefix + "/create/:entityId?/:subEntityId?" /* RoutePaths.Create */,
                    render: function (props) {
                        var _a = props.match.params, entityId = _a.entityId, subEntityId = _a.subEntityId;
                        var Create = CreatePage(entityId, subEntityId);
                        return React.createElement(Create, null);
                    },
                },
                guard: createRouteGuard,
            },
            {
                route: {
                    path: prefix + "/" /* RoutePaths.Home */,
                    exact: true,
                    render: function () {
                        var Home = HomePage(setContentNode, scrollContentRef);
                        return React.createElement(Home, null);
                    },
                },
            },
            {
                route: {
                    path: prefix + "/m365apps/:appId/:entityId?/:subPageId?" /* RoutePaths.M365Apps */,
                    component: AppHostPage,
                },
            },
            {
                route: {
                    path: prefix + "/mycontent/:entityId?/:subEntityId?" /* RoutePaths.MyContent */,
                    render: function (props) {
                        var _a = props.match.params, entityId = _a.entityId, subEntityId = _a.subEntityId;
                        var MyContent = MyContentPage(scrollContentRef, entityId);
                        return React.createElement(MyContent, null);
                    },
                },
                guard: myContentRouteGuard,
            },
            {
                route: {
                    path: prefix + "/copilotcmc/" /* RoutePaths.CopilotCmc */,
                    component: CopilotPage,
                },
                guard: copilotRouteGuard,
            },
            {
                route: {
                    path: prefix + "/launch/:app/content/" /* RoutePaths.Content */,
                    component: ContentPage,
                },
            },
            {
                route: {
                    path: prefix + "/launch/:app/" /* RoutePaths.Start */,
                    render: function (_a) {
                        var e_1, _b;
                        var location = _a.location;
                        var params = new URLSearchParams(location.search);
                        var paramsWithLowerKey = new URLSearchParams();
                        try {
                            for (var _c = __values(params.entries()), _d = _c.next(); !_d.done; _d = _c.next()) {
                                var _e = __read(_d.value, 2), key = _e[0], value = _e[1];
                                paramsWithLowerKey.append(key.toLowerCase(), value);
                            }
                        }
                        catch (e_1_1) { e_1 = { error: e_1_1 }; }
                        finally {
                            try {
                                if (_d && !_d.done && (_b = _c.return)) _b.call(_c);
                            }
                            finally { if (e_1) throw e_1.error; }
                        }
                        var appQuery = paramsWithLowerKey.get('ms.url');
                        var templateId = paramsWithLowerKey.get('templateid');
                        var StartPageComponent = StartPage(scrollContentRef, appQuery, templateId);
                        return React.createElement(StartPageComponent, null);
                    },
                },
                guard: startPageRouteGuard,
            },
            {
                route: {
                    path: prefix + "/news/" /* RoutePaths.News */,
                    component: NewsPage,
                },
            },
            {
                route: {
                    path: prefix + "/themetest/" /* RoutePaths.ThemeTest */,
                    component: ThemeTestPage,
                },
            },
            {
                route: {
                    path: prefix + "/apps/" /* RoutePaths.AppGallery */,
                    component: AppGalleryPage,
                },
            },
            {
                route: {
                    path: prefix + "/search/" /* RoutePaths.Search */,
                    render: function () { return (React.createElement(SearchPage, { searchRoot: prefix + "/search/" /* RoutePaths.Search */ })); },
                },
                guard: searchRouteGuard,
            },
            {
                route: {
                    path: prefix + "/search/content/" /* RoutePaths.SearchPersonScoped */,
                    render: function () { return (React.createElement(SearchPage, { searchRoot: prefix + "/search/" /* RoutePaths.Search */ })); },
                },
                guard: searchRouteGuard,
            },
            {
                route: {
                    path: prefix + "/search/overview/" /* RoutePaths.SearchPersonScopedOverview */,
                    render: function () { return (React.createElement(SearchPage, { searchRoot: prefix + "/search/" /* RoutePaths.Search */ })); },
                },
                guard: searchRouteGuard,
            },
            {
                route: {
                    path: prefix + "/search/files/" /* RoutePaths.SearchFilesScoped */,
                    render: function () { return (React.createElement(SearchPage, { searchRoot: prefix + "/search/" /* RoutePaths.Search */ })); },
                },
                guard: searchRouteGuard,
            },
            {
                route: {
                    path: prefix + "/search/people/" /* RoutePaths.SearchPeopleScoped */,
                    render: function () { return (React.createElement(SearchPage, { searchRoot: prefix + "/search/" /* RoutePaths.Search */ })); },
                },
                guard: searchRouteGuard,
            },
            {
                route: {
                    path: prefix + "/search/sites/" /* RoutePaths.SearchSitesScoped */,
                    render: function () { return (React.createElement(SearchPage, { searchRoot: prefix + "/search/" /* RoutePaths.Search */ })); },
                },
                guard: searchRouteGuard,
            },
            {
                route: {
                    path: prefix + "/search/main/" /* RoutePaths.ConsumerAllSearch */,
                    render: function () { return (React.createElement(SearchPage, { searchRoot: prefix + "/search/" /* RoutePaths.Search */ })); },
                },
                guard: searchRouteGuard,
            },
            {
                route: {
                    path: prefix + "/search/docs/" /* RoutePaths.ConsumerFileSearch */,
                    render: function () { return (React.createElement(SearchPage, { searchRoot: prefix + "/search/" /* RoutePaths.Search */ })); },
                },
                guard: searchRouteGuard,
            },
            {
                route: {
                    path: prefix + "/search/templates/" /* RoutePaths.ConsumerTemplateSearch */,
                    render: function () { return (React.createElement(SearchPage, { searchRoot: prefix + "/search/" /* RoutePaths.Search */ })); },
                },
                guard: searchRouteGuard,
            },
            {
                route: {
                    path: prefix + "/template/:app/" /* RoutePaths.Template */,
                    component: TemplatePage,
                },
            },
            {
                route: {
                    path: getAppHostedAtRootPath(prefix, MosAppsHostedAtRoot),
                    component: AppHostPage,
                },
                guard: mosAppHostedAtRootRouteGuard,
            },
            {
                route: {
                    path: prefix + "/copilot/" /* RoutePaths.Copilot */,
                    component: CopilotAppPage,
                },
            },
            {
                route: {
                    path: prefix + "/browse/devuitool/" /* RoutePaths.DevUITool */,
                    render: function () {
                        return React.createElement(BrowsePage, null);
                    },
                },
                guard: browseRouteGuard,
            },
        ];
    }
    return appRoutes;
}
//# sourceMappingURL=getOfficeHomeAppRoutes.js.map